import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';

const Title = ({ children }) => (
  <Typography component="h3" variant="subtitle1" color="primary">
    {children}
  </Typography>
);

Title.propTypes = {
  children: PropTypes.node,
};

export default Title;
